export function generateItemControlProperties(_a) {
    var allDocuments = _a.allDocuments, document = _a.document, index = _a.index, createDocumentActions = _a.createDocumentActions, onActionMenuToggledInternal = _a.onActionMenuToggled, onCommandMenuToggledInternal = _a.onCommandMenuToggled, onDocumentClick = _a.onDocumentClick, onMeetingArtifactClick = _a.onMeetingArtifactClick, onPathClick = _a.onPathClick, tags = _a.tags, onTagItemClick = _a.onTagItemClick;
    var itemElementId = "ew-item-".concat(index);
    var onDocClick = function (event) {
        onDocumentClick && onDocumentClick(document, index, event);
    };
    var onAttributionClick = function (event) {
        onPathClick && onPathClick(document, index, event);
    };
    var createDocumentActionsOptions = {
        createDocumentActions: createDocumentActions,
        itemElementId: itemElementId,
        index: index,
    };
    var onArtifactClick = function (meetingObj) {
        var matchedEdgeworthDoc = allDocuments.find(function (edgeworthDocument) { return meetingObj.id === edgeworthDocument.id; });
        if (matchedEdgeworthDoc) {
            onMeetingArtifactClick &&
                onMeetingArtifactClick(matchedEdgeworthDoc, index);
        }
        else {
            throw new Error("Cannot find a corresponding item with id: ".concat(meetingObj.id));
        }
    };
    var onActionMenuToggled = function (isOpen) {
        onActionMenuToggledInternal &&
            onActionMenuToggledInternal(isOpen, document);
    };
    var onCommandMenuToggled = function (isOpen) {
        onCommandMenuToggledInternal &&
            onCommandMenuToggledInternal(isOpen, document);
    };
    var tagItems;
    if (tags && tags.docIdToTagIdsMap.has(document.id)) {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        var tagIds = Array.from(tags.docIdToTagIdsMap.get(document.id));
        tagItems = tagIds
            .map(function (id) {
            return tags.tagIdToItemsDocumentIdsMap.has(id)
                ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    tags.tagIdToItemsDocumentIdsMap.get(id)[0]
                : undefined;
        })
            .filter(function (item) { return !!item; });
    }
    var onTagClick = function (tagItem) {
        return onTagItemClick === null || onTagItemClick === void 0 ? void 0 : onTagItemClick(tagItem, document);
    };
    return {
        createDocumentActionsOptions: createDocumentActionsOptions,
        itemElementId: itemElementId,
        onActionMenuToggled: onActionMenuToggled,
        onMeetingArtifactClick: onArtifactClick,
        onAttributionClick: onAttributionClick,
        onCommandMenuToggled: onCommandMenuToggled,
        onDocClick: onDocClick,
        tagItems: tagItems,
        onTagItemClick: onTagClick,
    };
}
//# sourceMappingURL=generateItemControlProperties.js.map